import { usePathname } from "next/navigation";
import { useEffect } from "react"

export function useRouteChange(effect: () => void) {
  const pathname = usePathname();
  useEffect(() => {
    effect()
  }, [pathname, effect])
}
